import React, { Component } from 'react';
import DarkThemeNav from '../common/dark-theme-nav';

class Toggles extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <section><a className="anchor" id="toggles"></a>

        <h2>Toggles</h2>
        <p>The toggle switch represents a physical switch and is used for actions to allow users to turn things on or off. The toggle component can be used in place of a checkbox control to denote the on or off state.</p>
        <p className="push-half--top">To add a toggle component to your page, just wrap a standard HTML checkbox input element as outlined below.</p>
        <p className="push-half--top">To use various sizes, add <code className="inline">.toggle__label-large, .toggle__label-medium, .toggle__label-small, .toggle__label-xsmall</code> to the <code className="inline">&lt;label&gt;</code> element.</p>
        <div className="callout"><strong>Note:</strong> The label element can be placed before or after the toggle, but it should be noted that, regardless of whether you would like the label to appear before or after the toggle, in the HTML the <code className="inline">&lt;label&gt;</code> element must be placed physically after the checkbox input element in the markup. This is due to a limitation in the current CSS specification.</div>
        <br/>
        <DarkThemeNav anchor="toggles" />
        <h4>Label Before</h4>
        <p>To place the label before the toggle apply the <code className="inline">.toggle__label-before</code> class to the label element.</p>
        <div className="toggle">
          <input id="switch1" type="checkbox" />
          <label htmlFor="switch1" className="toggle__label toggle__label-before">Default</label>
        </div>
        <br/>
        <pre><code className="language-html">{`<!-- HTML -->
<div class="toggle">
  <input id="switch1" type="checkbox">
  <label for="switch1" class="toggle__label toggle__label-before">Default</label>
</div>`}</code></pre>

        <h5 className="push--top push-quarter--bottom">Disabled State</h5>
        <div className="toggle push--right">
          <input id="switch2" type="checkbox" disabled />
          <label htmlFor="switch2" className="toggle__label toggle__label-before">Disabled / Unchecked</label>
        </div>
        <div className="toggle">
          <input id="switch3" type="checkbox" disabled checked />
          <label htmlFor="switch3" className="toggle__label toggle__label-before">Disabled / Checked</label>
        </div>

      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`<!-- Disabled / Unchecked -->
<div class="toggle">
  <input id="switch2" type="checkbox" disabled>
  <label for="switch2" class="toggle__label toggle__label-before">Disabled / Unchecked</label>
</div>

<!-- Disabled / Checked -->
<div class="toggle">
  <input id="switch3" type="checkbox" disabled checked>
  <label for="switch3" class="toggle__label toggle__label-before">Disabled / Checked</label>
</div>`}</code></pre>

        <br/>

        <h4>Label After</h4>
        <p>To place the label after the toggle apply the <code className="inline">.toggle__label-after</code> class to the label element.</p>
        <div className="toggle">
          <input id="switch4" type="checkbox" />
          <label htmlFor="switch4" className="toggle__label toggle__label-after">Default</label>
        </div>

        <br/>

        <pre><code className="language-html">{`<!-- HTML -->
<div class="toggle">
  <input id="switch4" type="checkbox">
  <label for="switch4" class="toggle__label toggle__label-after">Auto Refresh</label>
</div>`}</code></pre>

        <h5 className="push--top push-quarter--bottom">Disabled State</h5>
        <div className="toggle push--right">
          <input id="switch5" type="checkbox" disabled />
          <label htmlFor="switch5" className="toggle__label toggle__label-after">Disabled / Unchecked</label>
        </div>
        <div className="toggle">
          <input id="switch6" type="checkbox" disabled checked />
          <label htmlFor="switch6" className="toggle__label toggle__label-after">Disabled / Checked</label>
        </div>

      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`<!-- Disabled / Unchecked -->
<div class="toggle">
  <input id="switch5" type="checkbox" disabled>
  <label for="switch5" class="toggle__label toggle__label-after">Disabled / Unchecked</label>
</div>

<!-- Disabled / Checked -->
<div class="toggle">
  <input id="switch6" type="checkbox" disabled checked>
  <label for="switch6" class="toggle__label toggle__label-after">Disabled / Checked</label>
</div>`}</code></pre>
        <br/>
        <hr/>
      </section>
    );
  }
}
export default Toggles;



// WEBPACK FOOTER //
// ./styleguide/components/sections/Toggles.js